import React from 'react';
import ReactDOM from 'react-dom';

import {UserInfoState} from 'onboarding/new-user-flow/RoleInfoScreen';

interface Props {
  initialPhoneNumber?: string;
  initialTeamName?: string;
  initialTitle?: string;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent<HTMLFormElement>, state: UserInfoState) => void;
}

class VPCRoleInfoScreen extends React.Component<Props, UserInfoState> {
  state: UserInfoState = {
    phoneNumber: this.props.initialPhoneNumber || '',
    teamName: this.props.initialTeamName || '',
    title: this.props.initialTitle || '',
    company: null,
  };

  teamNameInputRef = React.createRef<HTMLInputElement>();

  componentDidMount(): void {
    (ReactDOM.findDOMNode(this.teamNameInputRef.current) as HTMLInputElement).focus();
  }

  fieldsValid = (): boolean =>
    this.state.teamName !== undefined &&
    this.state.teamName !== '' &&
    this.state.phoneNumber !== undefined &&
    this.state.phoneNumber !== '';

  render(): JSX.Element {
    const disableClickToNextScreen = !this.fieldsValid() || this.props.isLoading;

    // Keep required fields in sync with `benchling/start/views.py:100`
    return (
      <form
        onSubmit={(e): void => {
          this.props.onSubmit(e, this.state);
        }}
      >
        <label>
          Team <span className="u-danger-color">*</span>
        </label>
        <input
          name="teamName"
          placeholder="e.g. Protein Engineering"
          onChange={(e) => {
            this.setState({teamName: e.target.value});
          }}
          value={this.state.teamName ?? undefined}
          className="input-lg form-control u-spacing-bottom"
          ref={this.teamNameInputRef}
        />
        <label>Role</label>
        <input
          name="title"
          placeholder="e.g. Senior Scientist"
          onChange={(e) => {
            this.setState({title: e.target.value});
          }}
          value={this.state.title ?? undefined}
          className="input-lg form-control u-spacing-bottom"
        />
        <label>
          Phone number <span className="u-danger-color">*</span>
        </label>
        <input
          name="phoneNumber"
          placeholder="e.g. 415-555-5555"
          onChange={(e) => {
            this.setState({phoneNumber: e.target.value});
          }}
          value={this.state.phoneNumber ?? undefined}
          className="input-lg form-control u-spacing-bottom"
        />
        <div className="roleInfoScreen-nextScreenButtonContainer">
          <button
            className="button button--large button--primary u-spacing-top pull-right"
            disabled={disableClickToNextScreen}
            type="submit"
          >
            {this.props.isLoading ? 'Submitting details...' : 'Submit'}
          </button>
        </div>
      </form>
    );
  }
}

export default VPCRoleInfoScreen;
